import { Component, OnInit } from '@angular/core';
import { EmployeeReport } from 'src/app/shared/models/course';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { CourseService } from 'src/app/shared/services/course.service';
import { EmployeeReportViewComponent } from '../employee-report-view/employee-report-view.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-employee-report',
  templateUrl: './employee-report.component.html',
  styleUrls: ['./employee-report.component.scss']
})
export class EmployeeReportComponent implements OnInit {

  public employeeReport: EmployeeReport
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public context!: Context;
  constructor(private courseService: CourseService,
    private modalService: NgbModal,
    private authService:AuthService
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.courseService.getEmployeeTestReport(this.context?.employeeId).subscribe({
      next: (report: EmployeeReport) => {
        this.employeeReport = report;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  public viewEmployeeReport(report: EmployeeReport) {
    const modalRef = this.modalService.open(EmployeeReportViewComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.employeeReport = report;
  }
}
